export const CONVERSION_FACTORS = {
  CRORE: 10000000,
  LAKH: 100000,
  THOUSAND: 1000,
} as const;

export const UNIT_LABELS = {
  CRORE: "Cr",
  LAKH: "L",
  THOUSAND: "K",
} as const;
